<template lang="pug">
  div#conversa-main(:class="wrapperClass" ref="conversaMain" @click.stop)
    div#conversa-close-button.conversa_close_button(:class="closeBtnClass")
      a(href="#" @click="hideConversa()" class="hvr-forward")
        img(:src="get_img_url('ico_sofia_close.png')" class="conversa_close_button__icoCloseConversa")
    div#conversa-wrapper(
      :class="wrapperClass"
    )
</template>

<script>
import conversaMixin from 'common/mixins/conversa'
import { mapState, mapMutations, mapGetters } from 'vuex'

export default {
  mixins: [conversaMixin],
  name: 'conversa-wrapper-vue',
  data() {
    return {
      conversa: null,
      error: null,
      conversaRendered: false
    }
  },
  props: {
    from_rails: Boolean, default: false,
    userPermissionModules: { type: Array, default: () => [] },
  },
  computed: {
    ...mapState(["subscription_id"]),
    ...mapState('conversa', ['show_conversa', 'conversa_search']),
    display_conversa() {
      return (this.show_conversa || !this.from_rails) && this.conversa
    },
    wrapperClass() {
      return this.display_conversa ? 'showConversa' : ''
    },
    closeBtnClass() {
      return this.display_conversa && this.from_rails ? 'showButton' : 'hiddenButton'
    },
    ...mapGetters(["has_user_subscription"])
  },
  methods: {
    ...mapMutations('conversa', ['setShowConversa']),
    async buildConversa() {
      if (!this.conversaRendered) {
        const options = this.conversaOptions(undefined, this.conversa_search)
        this.conversa = new Conversa(options)
        await this.waitForConversaReady()
        this.render_conversa()
        this.conversaRendered = true
      }

      if (this.conversa_search) {
        this.conversa.eventBus.publish('sendQuestionFromSearchBox', this.conversa_search)
      }
    },
    async waitForConversaReady() {
      return new Promise((resolve, reject) => {
        const timeout = 5000
        const startTime = Date.now()

        const checkReady = () => {
          if (this.conversa && this.conversa.eventBus) {
            resolve()
          } else if (Date.now() - startTime > timeout) {
            reject(new Error('Conversa no se inicializó a tiempo.'))
          } else {
            setTimeout(checkReady, 50)
          }
        }
        checkReady()
      })
    },
    render_conversa() {
      if (this.conversa) {
        this.conversa.render('conversa-wrapper')
      }
    },
    hideConversa() {
      this.setShowConversa(false)
    },
    get_img_url(img_name) {
      return require('../../../assets/images/conversa/'+ img_name )
    },
    handleOutsideClick(event) {
      if (this.show_conversa) {
        if (!this.isClickInsideConversa(event) && !this.isClickOnAnyConversaButton(event)) {
          event.preventDefault();
          this.setShowConversa(false);
        }
      }
    },

    isClickInsideConversa(event) {
      return this.$refs.conversaMain && this.$refs.conversaMain.contains(event.target);
    },

    isClickOnAnyConversaButton(event) {
      return (
        this.isClickedOnConversaButton('conversaBtn', 0, event) ||
        this.isClickedOnConversaButton('conversaBtn', 1, event) ||
        this.isClickedOnConversaButton('conversa_expanded_button', 0, event)
      );
    },

    isClickedOnConversaButton(className, index, event) {
      const buttonElement = document.getElementsByClassName(className)[index];
      return buttonElement && buttonElement.contains(event.target);
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
  },
  watch: {
    async show_conversa() {
      if (this.show_conversa) {
        try {
          await this.buildConversa()
        } catch (error) {
          this.error = error
        }
      }
    }
  }
}
</script>
